import { render, staticRenderFns } from "./MySpacePriorityTasksWidget.vue?vue&type=template&id=11fbfe80&scoped=true&"
import script from "./MySpacePriorityTasksWidget.vue?vue&type=script&lang=js&"
export * from "./MySpacePriorityTasksWidget.vue?vue&type=script&lang=js&"
import style0 from "./MySpacePriorityTasksWidget.vue?vue&type=style&index=0&id=11fbfe80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fbfe80",
  null
  
)

export default component.exports